import { useCountDown } from 'ahooks';
import classNames from 'classnames';
import React, { Fragment, useEffect, useState } from 'react';
import './index.scss';

/**
 * 维护:谢保林
 * 倒计时
 * @param modify kalkin 2025/04/05
 * @param description 新增onCountdownEnd回调函数
 * @param version 1.0.1
 **/
export interface EcoCountDownProps {
    /**
     * 结束时间
     *
     * 2024-08-31 23:00:00 GMT+8
     *
     * 1725116400000
     */
    endTime?: string | number;
    /**
     * 倒计时结束回调
     */
    onCountdownEnd?: (data?: any) => void;
    /**
     * 单位(天)
     */
    tipsDay?: string;
    /**
     * 单位(时)
     */
    tipsHour?: string;
    /**
     * 单位(分)
     */
    tipsMinute?: string;
    /**
     * 单位(秒)
     */
    tipsSecond?: string;
    /**
     * 样式名
     */
    className?: string;
}
const getTwoNumberHandle = (number: number) => {
    return `00${number || 0}`.slice(-2);
};
/**
 * 维护:谢保林
 *
 * 倒计时
 */
const EcoCountDown: React.FC<EcoCountDownProps> = ({
    endTime,
    tipsDay = ':',
    tipsHour = ':',
    tipsMinute = ':',
    tipsSecond = '',
    className,
    onCountdownEnd,
}) => {
    const prefixCls = `eco-count-down`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const [countdown, formattedRes] = useCountDown({ targetDate: endTime });
    const [isClient, setIsClient] = useState(false); // 不加这个的话,会出现水合

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        if (countdown === 0 && onCountdownEnd) {
            onCountdownEnd();
        }
    }, [countdown, onCountdownEnd]);

    return (
        <div className={classes}>
            {isClient && (
                <Fragment>
                    <span className={`${prefixCls}-text1`}>{getTwoNumberHandle(formattedRes.days)}</span>
                    <span className={`${prefixCls}-text2`}>{tipsDay}</span>
                    <span className={`${prefixCls}-text1`}>{getTwoNumberHandle(formattedRes.hours)}</span>
                    <span className={`${prefixCls}-text2`}>{tipsHour}</span>
                    <span className={`${prefixCls}-text1`}>{getTwoNumberHandle(formattedRes.minutes)}</span>
                    <span className={`${prefixCls}-text2`}>{tipsMinute}</span>
                    <span className={`${prefixCls}-text1`}>{getTwoNumberHandle(formattedRes.seconds)}</span>
                    <span className={`${prefixCls}-text2`}>{tipsSecond}</span>
                </Fragment>
            )}
        </div>
    );
};

export default EcoCountDown;
